import html5 from '../../../assets/image/icon/html-5-logo-svgrepo-com.svg'
import css3 from '../../../assets/image/icon/css-fill-svgrepo-com.svg'
import scss from '../../../assets/image/icon/sass-alt-svgrepo-com.svg'
import js from '../../../assets/image/icon/javascript-svgrepo-com.svg'
import ts from '../../../assets/image/icon/typescript-svgrepo-com.svg'
import react from '../../../assets/image/icon/react-svgrepo-com.svg'
import redux from '../../../assets/image/icon/redux-svgrepo-com.svg'
import rest_api from '../../../assets/image/icon/iconApi.png'
import tdd_jest from '../../../assets/image/icon/jest-svgrepo-com.svg'
import antd from '../../../assets/image/icon/ant-design-svgrepo-com.svg'
import miu from '../../../assets/image/icon/material_ui_icon_137419.png'


type skillDataType={
    name:string
    icon:string
}
export const skillData:skillDataType[]=[
    {name:'html5',icon: html5},
    {name:'css3',icon:css3},
    {name:'scss',icon:scss},
    {name:'js',icon:js},
    {name:'ts',icon:ts},
    {name:'react',icon:react},
    {name:'redux',icon:redux},
    {name:'rest api',icon:rest_api},
    {name:'tdd-jest',icon:tdd_jest},
    {name:'antd',icon:antd},
    {name:'miu',icon:miu},

]